import {
  Component,
  ChangeDetectionStrategy,
  AfterViewInit,
} from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Observable, isObservable, of } from 'rxjs';
import { CodeName } from '../../service/lookup-service/code-name.model';

@Component({
  selector: 'formly-insel-type',
  templateUrl: './inpsel-type.component.html',
  styleUrls: ['./inpsel-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InpselTypeComponent
  extends FieldType<FieldTypeConfig>
  implements AfterViewInit
{
  ngAfterViewInit(): void {
    queueMicrotask(() => {
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();

      this.formControl.updateValueAndValidity({ emitEvent: true });
    });
  }

  get options$(): Observable<CodeName[]> {
    const opts = this.to.options ?? [];
    return isObservable(opts) ? opts : of(opts);
  }

  isSelect(): boolean {
    return (this.to as any)['componentType']=='select';
  }

  isDateTime(): boolean {
    return (this.to as any)['componentType']=='datetime';
  }

  isInput():boolean{
    return (this.to as any)['componentType']=='input';
  }
}
